/**
 * Tabla con columnas declarativas, búsqueda y orden opcional por columna.
 * @param {{
 *   columns: Array<{ key:string, label:string, align?:string, sortable?:boolean, format?:string }>,
 *   rows: Array<Record<string, unknown>>,
 *   emptyText?: string,
 *   search?: string,
 *   onSearchChange?: (v:string)=>void,
 *   sortKey?: string,
 *   sortDir?: 'asc'|'desc',
 *   onSort?: (key:string)=>void
 * }} props
 */
import { formatAnalyticsCell } from '../utils/format-number.js';

export default function SimpleTable({
  columns,
  rows,
  emptyText = 'Sin datos disponibles.',
  search,
  onSearchChange,
  sortKey,
  sortDir,
  onSort
}) {
  const cols = Array.isArray(columns) ? columns : [];
  const list = Array.isArray(rows) ? rows : [];
  const canSort = typeof onSort === 'function';

  return (
    <div className="analytics-simple-table-wrap">
      {onSearchChange ? (
        <label className="analytics-field analytics-table-search">
          <span className="visually-hidden">Buscar</span>
          <input
            type="search"
            placeholder="Buscar…"
            value={search || ''}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Buscar en la tabla"
          />
        </label>
      ) : null}
      <div className="analytics-panel analytics-panel-scroll">
        {!list.length ? (
          <p className="analytics-empty">{emptyText}</p>
        ) : (
          <table className="analytics-table">
            <thead>
              <tr>
                {cols.map((c) => {
                  const sortable = canSort && c.sortable !== false;
                  const active = sortKey === c.key;
                  const ariaSort = !sortable
                    ? undefined
                    : active
                      ? sortDir === 'asc'
                        ? 'ascending'
                        : 'descending'
                      : 'none';
                  const label =
                    c.label + (active ? (sortDir === 'asc' ? ' ↑' : ' ↓') : sortable ? '' : '');
                  if (!sortable) {
                    return (
                      <th key={c.key} className={c.align === 'right' ? 'num' : undefined}>
                        {c.label}
                      </th>
                    );
                  }
                  return (
                    <th
                      key={c.key}
                      className={
                        (c.align === 'right' ? 'num ' : '') + 'analytics-th-sortable'
                      }
                      aria-sort={ariaSort}
                    >
                      <button
                        type="button"
                        className={
                          'analytics-th-sort-btn' + (active ? ' is-active' : '')
                        }
                        onClick={() => onSort(c.key)}
                      >
                        {label}
                      </button>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {list.map((row, i) => (
                <tr key={row.id || i}>
                  {cols.map((c) => {
                    const raw = row[c.key];
                    const shown =
                      raw == null || raw === '' ? '—' : formatAnalyticsCell(raw, c);
                    return (
                      <td key={c.key} className={c.align === 'right' ? 'num' : undefined}>
                        {shown}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
